import React from 'react'
import { useCmsBlock } from 'lib/core/hooks'
import { CMS_BLOCK } from 'app/sofia/resources/constants'
import { Container } from './styled'

export const Brands = () => {
  const staticBlockID = CMS_BLOCK.HOME_BRANDS
  const staticBlock = useCmsBlock({
    id: staticBlockID,
    isLazy: false
  })

  if (!staticBlock.content) return null

  return (
    <Container>
      <div
        dangerouslySetInnerHTML={{
          __html: staticBlock?.content ?? ''
        }}
      />
    </Container>
  )
}
